export const TnCContents = [
  {
    description:
      'This Agreement is between GoTu Technology, Inc. (“GoTu”), and You, a  licensed Dentist or Dental Office, to connect with each other for the purposes of engaging GoTu as a recruiter to help find You a Permanent Placement licensed, National Board of Dental Hygiene Certified Registered Dental Hygienist, Dental Assistant, or Associate Dentist (collectively “Permanent Dental Auxiliary Personnel”) to provide Dental Care Services. ',
    id: 'I',
    title: 'Agreement',
  },
  {
    description:
      'You agree that You (a) are a licensed Dentist or Dental Office; (b) are 18 years of age or older, (c) have not been previously suspended or removed from GoTu Platform; (d) do not have more than one Account on the Platform, and (e) have full power and authority to enter into this Agreement and in so doing will not violate any other agreements to which You are a party.',
    id: 'II',
    title: 'You',
  },
  {
    description:
      'You will provide GoTu with a description of the Permanent Placement job, salary and benefits information, and required candidate qualifications including, but not limited to, experience and education. The date you provide GoTu this description shall be the “Date of the Posted Month.” GoTu will submit Permanent Dental Auxiliary Personnel candidates’ resume or curriculum vitae (CV) to You.',
    id: 'III',
    title: 'Recruitment Service',
  },
  {
    description: '',
    id: 'IV',
    title: 'Permanent Placement Skills Assessment',
    children: [
      {
        description:
          'If Permanent Dental Auxiliary Personnel candidates meet Your professional qualifications, You may decide to have Permanent Dental Auxiliary Personnel candidates complete a Skills Assessment. GoTu has no decision-making authority in who is selected for a Skills Assessment and no role in assessing or determining Permanent Dental Auxiliary Personnel candidates’ performance in the Skills Assessment. If Permanent Dental Auxiliary Personnel candidates are selected for a Skills Assessment, they will complete a 3-hour Skills Assessment with You where You will observe them perform Dental Care Services. ',
        id: 'a',
        title: '',
      },
      {
        description:
          'You agree to pay a Skills Assessment fee to the Permanent Dental Auxiliary Personnel candidate for their time completing the Skills Assessment. GoTu facilitates payments from You to the Permanent Dental Auxiliary Personnel candidate for the Skills Assessment.',
        id: 'b',
        title: '',
      },
      {
        description:
          'Permanent Dental Auxiliary Personnel candidates may obtain access to Your non-public proprietary information during the completion of the Skills Assessment, including without limitation bill rates, requests for placement, costs, profits, margins, markets, sales, business processes, information systems, and any other information of a similar nature (“Confidential Information”).  Permanent Dental Auxiliary Personnel candidates agree to use, share, or copy such Confidential Information only as needed and permitted to complete their duties for the Skills Assessment, and to use reasonable measures to safeguard such information in hard copy or electronic form.  Within two business days of the conclusion of the Skills Assessment or their Agreement with GoTu, or sooner if instructed by GoTu, they shall return all Confidential Information and retain no copies.',
        id: 'c',
        title: '',
      },
    ],
  },
  {
    description:
      'Only You can extend a Permanent Placement offer to Permanent Dental Auxiliary Personnel candidates and Gotu does not have any input or involvement in the hiring process or decisions made by You.',
    id: 'V',
    title: 'Permanent Placement Selection',
  },
  {
    description:
      'You understand and agree that GoTu is acting solely as a recruiter to You. You agree that nothing under this Agreement is intended, nor shall it be construed, to create a partnership, employer-employee relationship, or joint venture between GoTu and You. Neither party nor their respective agents, employees, or independent contractors shall have any authority to bind the other party without the other party’s express written consent.',
    id: 'VI',
    title: 'Relationship Between GoTu and You',
  },
  {
    description: 'You acknowledge, understand, represent and warrant',
    id: 'VII',
    title: 'Your Representations and Warranties',
    children: [
      {
        description:
          'The person executing this Agreement on behalf of Your has the authority to legally bind the Agreement.',
        id: 'a',
        title: '',
      },
      {
        description:
          'You are fully licensed to practice Dentistry. Any licenses, certifications and insurances required by the State Board of Dentistry are in compliance and up to date. Any insurance required by the Dentist/Dental Office will be applied to the Permanent Dental Auxiliary Personnel.',
        id: 'b',
        title: '',
      },
      {
        description:
          'You determine in Your sole discretion which Permanent Dental Auxiliary Personnel candidates to complete a Skills Assessment and hire as Permanent Placements.',
        id: 'c',
        title: '',
      },
      {
        description:
          'GoTu is not the employer of or joint employer with any Dental Auxiliary Personnel. Dental Auxiliary Personnel are not employees, agents, or legal representatives of GoTu.',
        id: 'd',
        title: '',
      },
    ],
  },
  {
    description: '',
    id: 'VIII',
    title: 'Billing and Payment Terms',
    children: [
      {
        description:
          'You shall pay GoTu a monthly subscription fee of $450 for each Permanent Placement job GoTu is providing Recruitment Services for under the Agreement (“Monthly Subscription”). The Agreement and Monthly Subscription fee will automatically renew for another Month unless You have closed the Permanent Placement job and it is in a closed status on the Date of Renewal.',
        id: 'a',
        title: '',
      },
      {
        description:
          'For purposes of this Agreement the “Date of Renewal” is the same Date of the Posted Month in the following month (e.g., job posted on January 16, the Day of Renewal is February 16). If the job is posted on a Date of the Posted Month that is longer than the number of days in the following month, the Monthly Subscription Date of Renewal is the last day of the following month (e.g., job posted on March 31, the Day of Renewal is April 30).',
        id: 'b',
        title: '',
      },
      {
        description:
          'GoTu has sole discretion to waive any circumvention fee that another agreement between You and GoTu may provide should You hire or contract with any Dental Auxiliary Personnel within GoTu’s network, after the Dental Auxiliary Personnel has been engaged through the GoTu’s platform.',
        id: 'c',
        title: '',
      },
      {
        description:
          'Payment is due immediately on the Date of the Posted Month and Date of Renewal (as applicable) and shall be charged via the payment method on record unless agreed upon in writing between GoTu and You. You will receive a generated electronic statement reflecting the total amount charged to the select payment method. All statements will identify the Permanent Placement job, Monthly Subscription Fee, and the Date of Renewal. If Permanent Dental Auxiliary Personnel candidates complete a Skills Assessment, the statement will also include the date, time, and location of the Skills Assessment, Permanent Placement job, and Dental Auxiliary Personnel candidate name.',
        id: 'd',
        title: '',
      },
      {
        description:
          'You are required to have a form of payment on ﬁle with GoTu that is either credit/debit card, ACH, or invoicing. You will be charged a processing fee of 3.5% if charges are paid with credit cards. Credit/debit cards payments are processed by Stripe, and You must agree to the Stripe terms and conditions. The ACH payments are processed through Plaid, and You must agree to the Plaid terms and conditions.',
        id: 'e',
        title: '',
      },
      {
        description:
          'You are required to pay GoTu the entire subscription fee immediately or within the agreed upon terms with GoTu. Failure to make a timely payment shall result in GoTu ’s discretion to change an interest penalty of 1.5% per month, for each month or part thereof on the outstanding amount owed (not to exceed the highest rate allowed by law) until all amounts owed, including the interest, have been paid in full, or an automatic withdrawal of the amount owed on the fifth (5th) business day after the agreed upon payment terms have passed.',
        id: 'f',
        title: '',
      },
      {
        description:
          'If GoTu incurs costs or expenses to collect its fees or other sums due under this Agreement or to enforce any non-monetary terms of this Agreement or as result of Your default under this Agreement, You agree to pay to GoTu any and all such costs and expenses (including, but not limited to, reasonable attorneys’ fees and disbursements) incurred by GoTu in connection therewith.',
        id: 'g',
        title: '',
      },
    ],
  },
  {
    description: '',
    id: 'IX',
    title: 'Termination',
    children: [
      {
        description:
          'The term of this Agreement shall commence on and be effective as of the date of this Agreement is first accepted by you and will continue until this Agreement is terminated in accordance with the terms and conditions herein.',
        id: 'a',
        title: '',
      },
      {
        description:
          'Except as otherwise provided herein, You can terminate this Agreement with or without cause by providing prior written notice to GoTu of such termination. Any termination of this Agreement in accordance with the foregoing shall be effective after the 30-day period expires for the posted Permanent Placement job(s).',
        id: 'b',
        title: '',
      },
      {
        description:
          'Notwithstanding anything to the contrary in this Agreement, GoTu may terminate this Agreement immediately, with respect to you in the event you are in material breach of this Agreement, including but not limited to failing to make timely payment in accordance with the Agreement. Any failure by GoTu to assert a right or provision of this Section of shall not constitute a waiver of such right or provision.',
        id: 'c',
        title: '',
      },
    ],
  },
  {
    description:
      'Dental Auxiliary Personnel candidates are presented to You in complete confidence. Your retention of Dental Auxiliary Personnel candidates’ resume, and any other information provided by GoTu regarding them and/or the transcription, copying, or reproduction by any means shall not be distributed to any third party.  You agree to only share Dental Auxiliary Personnel candidates’ resume with an affiliate of You.',
    id: 'X',
    title: 'Confidentiality',
  },
  {
    description:
      'GoTu does not discriminate on the basis of sex, color, race, national origin, religion, gender, gender identity, marital status, age, sexual orientation, or any other applicable federal, state, or local protected class.',
    id: 'XI',
    title: 'Nondiscrimination',
  },
  {
    description:
      'This Agreement shall be the entire understanding and agreement between the parties with respect to the subject matter set forth herein, and all prior agreements, understandings, covenants, promises, warranties and representations, oral or written, express or implied, not incorporated herein are superseded hereby. The parties have had ample time to review this Agreement and, as a result, the Agreement will not be construed against a party because it may have drafted it.',
    id: 'XII',
    title: 'Entirety',
  },
  {
    description:
      'This Agreement may not be amended, modified, altered, supplemented or changed in any way except in writing, signed by the parties. The parties agree that they shall not rely upon any oral statement or conduct to infer that the Agreement has been amended, modified, altered, supplemented or changed in any way.',
    id: 'XIII',
    title: 'Amendment',
  },
  {
    description:
      'This Agreement shall be governed by the laws of the State of Florida without regard to Florida’s conflicts of law rules.',
    id: 'XIV',
    title: 'Governing Law & Venue',
  },
  {
    description:
      'This Agreement may be executed in counterparts, provided that the copies are identical in substance.',
    id: 'XV',
    title: 'Multiple Counterparts',
  },
  {
    description:
      'Headings or other subdivisions of this Agreement are inserted for convenience of reference and shall not limit or affect the legal construction of any provision hereof.',
    id: 'XVI',
    title: 'Headings',
  },
  {
    description:
      'You warrant that You have full authority to accept this Agreement and Your electronic acceptance serves as Your legally binding signature to this Agreement.',
    id: 'XVII',
    title: 'Signature',
  },
];
